<template>
    <div>
        <div class="form-group row">
            <label for="nom"  class="col-sm-3 col-form-label"><i class="fas fa-font"></i> Nom</label>
            <div class="col-sm-9">
                <input type="text" class="form-control" id="nom" v-model="filtre.nom" placeholder="Recherche par titre, auteur, code" @input="$emit('search')">
            </div>
        </div>

        <div class="form-group row">
            <label for="age"  class="col-sm-3 col-form-label"><i class="fas fa-child"></i> Age</label>
            <div class="col-sm-2">
                <small v-if="filtre.age == 0">pas de limite</small>
                <span v-else>{{ filtre.age }} ans</span>
            </div>
            <div class="col-sm-7">
                <input type="range" class="form-control-range" id="age" max="18" min="0" step="1" value="0" v-model="filtre.age" @change="$emit('search')">
            </div>
        </div>

        <div class="form-group row">
            <label for="joueurs" class="col-sm-3 col-form-label"><i class="fas fa-users"></i> Joueurs</label>
            <div class="col-sm-2">
                <small v-if="filtre.joueurs == 0">pas de limite</small>
                <span v-else>{{ filtre.joueurs }} joueurs</span>
            </div>
            <div class="col-sm-7">
                <input type="range" class="form-control-range" id="joueurs" max="10" min="0" step="1" value="0" v-model="filtre.joueurs" @change="$emit('search')">
            </div>
        </div>

        <div class="form-group row">
            <label for="duree" class="col-sm-3 col-form-label"><i class="fas fa-clock"></i> Dur&eacute;e</label>
            <div class="col-sm-2">
                <small v-if="filtre.duree == 0">pas de limite</small>
                <span v-else>{{ filtre.duree }} min</span>
            </div>
            <div class="col-sm-7">
                <input type="range" class="form-control-range" id="duree" list="duree" max="180" min="0" step="5" value="0" v-model="filtre.duree" @change="$emit('search')">
                <datalist id="duree">
                    <option value="" label="*"></option>
                    <option value="5" label="5 min"></option>
                    <option value="10"></option>
                    <option value="20"></option>
                    <option value="30" label="30 min"></option>
                    <option value="45"></option>
                    <option value="60" label="1 h"></option>
                    <option value="90" label="1 h 30"></option>
                    <option value="120" label="2 h"></option>
                    <option value="180" label="3 h"></option>
                </datalist>
            </div>
        </div>

        <div class="form-group row">
            <label for="type" class="col-sm-3 col-form-label"><i class="fas fa-cogs"></i> Type <small>(classification)</small></label>
            <div class="col-sm-9">
                <select id="type" class="form-control" v-model="filtre.type" @change="$emit('search')">
                    <option value="">(tous types)</option>
                    <option value="">(non class&eacute;)</option>
                    <option value="1">Tout petit et pr&eacute;-maternelle</option>
                    <option value="1.1">&nbsp;&nbsp;Premier age</option>
                    <option value="1.2">&nbsp;&nbsp;Eveil des 5 sens</option>
                    <option value="1.3">&nbsp;&nbsp;Jouets sensori-moteur</option>
                    <option value="2">Eveil de l'intelligence</option>
                    <option value="2.1">&nbsp;&nbsp;Puzzles</option>
                    <option value="2.2">&nbsp;&nbsp;Jouets à assembler</option>
                    <option value="2.3">&nbsp;&nbsp;Acquisition des connaissances</option>
                    <option value="2.4">&nbsp;&nbsp;Initiation scientifique et technique</option>
                    <option value="2.5">&nbsp;&nbsp;Casse-tête, solitaire</option>
                    <option value="2.6">&nbsp;&nbsp;R&eacute;flexion et observation</option>
                    <option value="3">Sportifs et action</option>
                    <option value="3.1">&nbsp;&nbsp;Jeux d'adresse</option>
                    <option value="3.2">&nbsp;&nbsp;Ext&eacute;rieur et plage</option>
                    <option value="3.3">&nbsp;&nbsp;Physiques et d'int&eacute;rieur</option>
                    <option value="3.4">&nbsp;&nbsp;Eau</option>
                    <option value="4">Imitation, identification et projection</option>
                    <option value="4.1">&nbsp;&nbsp;Objets de reproduction du monde r&eacute;el</option>
                    <option value="4.1.1">&nbsp;&nbsp;&nbsp;&nbsp;Poup&eacute;es et accessoires</option>
                    <option value="4.1.2">&nbsp;&nbsp;&nbsp;&nbsp;Maison et objets familliers</option>
                    <option value="4.1.3">&nbsp;&nbsp;&nbsp;&nbsp;Ecole et m&eacute;tier</option>
                    <option value="4.1.4">&nbsp;&nbsp;&nbsp;&nbsp;Garage, v&eacute;hicule, engin</option>
                    <option value="4.1.5">&nbsp;&nbsp;&nbsp;&nbsp;Train et circuit</option>
                    <option value="4.2">&nbsp;&nbsp;Jouets musicaux</option>
                    <option value="4.3">&nbsp;&nbsp;Univers et figurines</option>
                    <option value="4.4">&nbsp;&nbsp;Panoplie</option>
                    <option value="5">Soci&eacute;t&eacute;</option>
                    <option value="5.1">&nbsp;&nbsp;Th&eacute;matique</option>
                    <option value="5.2">&nbsp;&nbsp;Strat&eacute;gie et tactique</option>
                    <option value="5.3">&nbsp;&nbsp;M&eacute;moire et observation</option>
                    <option value="5.4">&nbsp;&nbsp;Coop&eacute;ration</option>
                    <option value="5.5">&nbsp;&nbsp;Communication</option>
                    <option value="5.6">&nbsp;&nbsp;Acquisition des connaissances</option>
                    <option value="5.7">&nbsp;&nbsp;Hasard</option>
                    <option value="5.8">&nbsp;&nbsp;Cartes</option>
                    <option value="5.9">&nbsp;&nbsp;Dexterite et adresse</option>
                    <option value="5.10">&nbsp;&nbsp;Rôle et fiction</option>
                    <option value="6">Cr&eacute;ation</option>
                    <option value="6.1">&nbsp;&nbsp;Mosaïque, tampons</option>
                    <option value="6.2">&nbsp;&nbsp;Mat&eacute;riel activit&eacute;s manuelles</option>
                    <option value="6.3">&nbsp;&nbsp;marionnettes</option>
                    <option value="7">&Eacute;lectronique</option>
                    <option value="7.1">&nbsp;&nbsp;De soci&eacute;t&eacute;, d'&eacute;veil, digitaux</option>
                    <option value="7.2">&nbsp;&nbsp;Consoles</option>
                    <option value="8">Vid&eacute;o, cassettes, logiciels, livres</option>
                    <option value="8.1">&nbsp;&nbsp;Cassettes de jeux</option>
                    <option value="8.2">&nbsp;&nbsp;Jeux videos, dvd</option>
                    <option value="8.3">&nbsp;&nbsp;Livres-jeux</option>
                </select>
            </div>
        </div>

        <div class="form-group row">
            <label for="categorie" class="col-sm-3 col-form-label"><i class="fas fa-swatchbook"></i> Cat&eacute;gorie <small>(emplacement)</small></label>
            <div class="col-sm-9">
                <select id="categorie" class="form-control" v-model="filtre.categorie" @change="$emit('search')">
                    <option value="">(toutes cat&eacute;gories)</option>
                    <option value="1">2 ans et +</option>
                    <option value="2">4 ans et +</option>
                    <option value="3">5 ans et +</option>
                    <option value="4">6 ans et +</option>
                    <option value="5">7 ans et +</option>
                    <option value="7">Adresse</option>
                    <option value="9">Cartes</option>
                    <option value="10">Educatif</option>
                    <option value="11">Communication</option>
                    <option value="12">Construction</option>
                    <option value="13">Coop&eacute;ration</option>
                    <option value="14">Cr&eacute;atif</option>
                    <option value="15">D&eacute;guisements</option>
                    <option value="16">Divers</option>
                    <option value="17">Eau</option>
                    <option value="18">&Eacute;lectronique</option>
                    <option value="19">Eveil</option>
                    <option value="21">Ext&eacute;rieur</option>
                    <option value="22">Grands Jeux</option>
                    <option value="23">Imitation</option>
                    <option value="24">Int&eacute;rieur</option>
                    <option value="27">Livres</option>
                    <option value="28">Musique</option>
                    <option value="29">Puzzles</option>
                    <option value="31">Solitaires</option>
                    <option value="32">Strat&eacute;gie</option>
                    <option value="33">Th&egrave;me</option>
                    <option value="34">V&eacute;hicules</option>
                    <option value="35">Jeux à deux</option>
                    <option value="36">Jeux sur place</option>
                    <option value="37">Coop&eacute;ratif Adulte</option>
                    <option value="38">Gestion</option>
                    <option value="39">D&eacute;couverte Scientifique</option>
                    <option value="40">Assemblage</option>
                    <option value="41">Escape Game</option>
                    <option value="42">Malle anniversaire</option>
                </select>
            </div>
        </div>

        <div class="form-group row">
            <label for="dispo" class="col-sm-3 col-form-label"><i class="fas fa-clipboard-check"></i> Uniquement ceux disponibles</label>
            <div class="col-sm-9">
                <input type="checkbox" id="dispo" v-model="filtre.dispo" @change="$emit('search')">
            </div>
        </div>

        <div class="form-group row">
            <div class="col-sm-9">
                <button class="btn btn-primary" @click.prevent="$emit('search')">Rechercher</button>
                <button class="btn btn-secondary" @click.prevent="$emit('reset')">Reset</button>
            </div>
        </div>

    </div>
</template>

<script>
export default {
    props: ['filtre']
}
</script>

<style scoped>
.slider-wrapper {
  display: inline-block;
  width: 20px;
  height: 150px;
  padding: 0;
}
.slider-wrapper input {
  width: 150px;
  height: 20px;
  margin: 0;
  transform-origin: 75px 75px;
  transform: rotate(-90deg);
}
/*
    Override conflict from stylesheet ludopen_web-style-css
*/
/* .btn-group-lg, .btn-lg {
    font-size: inherit;
} */
.btn, .btn-lg, .btn-group-lg, .form-control {
    font-size: inherit;
}
select.form-control:not([size]):not([multiple]) {
    height: inherit;
}
</style>


// WEBPACK FOOTER //
// src/components/jeuxfiltre.vue